import SearchProductList from './components/SearchProductList';

const SearchProductListPage = () => {
  return (
    <div>
      <SearchProductList />
    </div>
  );
};

export default SearchProductListPage;
